import React from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { uiAdjustedUserObject } from 'relevant-shared/misc/userUtils';
import { stores } from '../../stores';
import { useHeartbeat } from '../../hooks/useActiveUsers';
import { Avatar, UserAvatar } from '../Avatar';
import { Cooltip } from '../ViewEditReport/Cooltip';

function ActiveUsers({
	max,
	hideOverflow,
}: {
	max?: number;
	hideOverflow?: boolean;
}) {
	const [autoAnimateRef] = useAutoAnimate();
	const { data: activeUsers = [] } = useHeartbeat();
	const isSuperAdmin = stores.identity.isSuperAdministrator();

	return (
		<>
			{/* Only show if any other users are active than just ourselves */}
			{activeUsers.length > 1 && (
				<Cooltip
					content={(
						<div className="flex flex-col gap-2 p-1 overflow-y-scroll max-h-[300px] scrollbar-thin">
							<span className="text-sm font-medium">Active Users</span>
							{activeUsers.map((user) => uiAdjustedUserObject(user, isSuperAdmin)).map((user) => (
								<div key={user.id} className="flex gap-2 items-center">
									<UserAvatar userId={user.id} />
									<div className="flex flex-col">
										<span className="text-sm font-medium leading-none whitespace-nowrap">{user.fullname}</span>
										<span className="text-xs text-grey-500">{user.email}</span>
									</div>
								</div>
							))}
						</div>
					)}
					className="p-3!"
					placement="bottom"
				>
					<div ref={autoAnimateRef} className="flex -space-x-2">
						{activeUsers.slice(0, max ?? undefined).map((user) => (
							<UserAvatar key={user.id} userId={user.id} />
						))}
						{max && activeUsers.length > max && !hideOverflow && (
							<Avatar key="overflow" text={`+${activeUsers.length - max}`} />
						)}
					</div>
				</Cooltip>
			)}
		</>
	);
}

export default ActiveUsers;
